import { Sidenav } from '../organisms/sidenav/sidenav';
import { Toolbar } from '../organisms/toolbar/toolbar';

import { ReactNode } from 'react';
import avatarImage from '../assets/avatar-broker.jpg';

interface IDefaultLayout {
  children: ReactNode;
  name: string;
  initials: string;
  onLogout?: () => void;
}

export function DefaultLayout(props: IDefaultLayout) {
  const { children, name, initials, onLogout } = props;

  return (
    <div className="layout-grid">
      <Sidenav className="area-navigation h-dvh top-0 sticky" />
      <Toolbar
        className="area-topbar sticky top-0 h-[--toolbar-height]"
        name={name}
        avatar={{
          initials,
          src: avatarImage,
          alt: 'Lorem ipsum',
        }}
        menuItems={[
          {
            text: 'Logout',
            onAction: onLogout,
          },
        ]}
        notificationCount={9}
      />
      <main className="area-content">{children}</main>
    </div>
  );
}
